import React from 'react'
import { useIntl } from 'react-intl'
import { Icons } from 'msp-components'
import { ChevronRightIcon } from '@heroicons/react/solid'
import FilterCount from './FilterCount'

type FiltersMobileButtonProps = {
  filterCount?: number
  onOpen: () => void
}

const FiltersMobileButton = ({
  filterCount = 0,
  onOpen
}: FiltersMobileButtonProps) => {
  const { formatMessage } = useIntl()
  return (
    <div
      className='flex h-12 w-full cursor-pointer flex-nowrap rounded-sm border border-black fill-black px-5 align-middle'
      onClick={onOpen}
    >
      <div className='font-Roboto text-14 tracking-0 flex w-full flex-row flex-nowrap items-center whitespace-nowrap'>
        <div className='mr-5'>
          <Icons iconName='Customizability' height='18px' width='18px' />
        </div>
        {formatMessage({
          defaultMessage: 'Filter products',
          id: 'msp.product_list.button.mobile_filter_products'
        })}
        <span>
          <FilterCount count={filterCount} />
        </span>
      </div>
      <div className='flex min-w-min items-center justify-end'>
        <ChevronRightIcon className='h-5 w-5' aria-hidden='true' />
      </div>
    </div>
  )
}

export default FiltersMobileButton
